import { IRootState } from '../../../../../store'
import { IBodySurveyState } from '../store/bodySurvey.types'

export const getBodySurveySelector = (state: IRootState): IBodySurveyState => state.bodySurvey
